"use client";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SectionBox from "../layout/SectionBox";
import { useOurServiceStore } from "../../store/ourServiceStore";
import PageLoader from "../../components/atoms/PageLoader";

export default function OurServiceGrid() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const lang: "en" | "id" = location.pathname.startsWith("/id") ? "id" : "en";

  const { ourservices, fetchOurServices } = useOurServiceStore();

  useEffect(() => {
    fetchOurServices(lang).finally(() => setLoading(false));
  }, [lang, fetchOurServices]);

  return (
    <section className="w-full pt-6 relative">
        {loading && <PageLoader />}
      <div className="container-section mx-auto px-6">
        <SectionBox background="white" classNameSub="!mb-0 space-y-24">
          {ourservices.map((item, index) => {
            const isImageRight = item.imagePosition === "right";

            return (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center md:mb-12 mb-8"
              >
                {/* IMAGE */}
                <div
                  className={`flex justify-center ${
                    isImageRight ? "md:order-2" : "md:order-1"
                  }`}
                >
                  <img
                    src={item.image_desktop}
                    alt={item.title[lang]}
                    className="w-full rounded-xl object-cover"
                  />
                </div>

                {/* TEXT */}
                <div
                  className={`space-y-4 ${
                    isImageRight ? "md:order-1" : "md:order-2"
                  }`}
                >
                  <h2 className="text-2xl md:text-3xl font-bold text-primary">
                    {item.title[lang]}
                  </h2>

                  {item.sub_title?.[lang] && (
                    <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide">
                      {item.sub_title[lang]}
                    </h3>
                  )}

                  <div
                    className="text-black leading-relaxed space-y-4 text-justify"
                    dangerouslySetInnerHTML={{
                      __html: item.content[lang],
                    }}
                  />
                </div>
              </div>
            );
          })}
        </SectionBox>
      </div>
    </section>
  );
}